import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useState } from "react";
import { getMeetingTitleByMeeting } from "app/utils/appHelpers";
import { meetingTitleTextColor } from "config";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentAgenda, setCurrentAgendaList, setCurrentMeeting, setCurrentMeetingParticipants, setCurrentMeetingReviewList, setCurrentMeetingUsers, setCurrentMeetingVoteList } from "stores/meeting";
import MeetingCard from "../Card/MeetingCard";



function AddUpdateMeetingDialog({ onClose, open, afterUpdateFunc, addAfterTable, updateDecisionCount }) {

    const dispatch = useDispatch();
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [value, setValue] = useState(0);
    const [tabsLength, setTabsLength] = useState(0);


    const handleClose = (event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }


        dispatch(setCurrentMeeting({}))
        dispatch(setCurrentAgenda({}))
        dispatch(setCurrentAgendaList([]))
        dispatch(setCurrentMeetingUsers([]));
        dispatch(setCurrentMeetingParticipants([]))
        dispatch(setCurrentMeetingReviewList(null))
        dispatch(setCurrentMeetingVoteList(null))

        setValue(0);
        onClose();
    };



    const handlePreviousTab = () => {
        if (value > 0) {
            setValue(value - 1);
        }
    };

    const handleNextTab = () => {

        if (value < tabsLength - 1) {
            setValue(value + 1);
        }
    };


    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [saveButtonStatus, setSaveButtonStatus] = useState(false);

    const handleSaveButtonClick = async () => {
        setSaveButtonStatus(true)
    }
    const [isFullScreen, setIsFullScreen] = useState(true);


    return (
        <Dialog

            onClose={handleClose}
            open={Boolean(open)}
            fullWidth
            fullScreen={value === 3 ? isFullScreen : false}
            sx={{
                '& .MuiDialog-paper': {

                    width: '100%',
                    maxWidth: value === 3 && isFullScreen ? 'none' : value === 0 ? '70%' : '95%',
                    height: value === 3 && isFullScreen ? '100%' : 'auto',


                    p: 0,
                    m: 0,
                },
            }}
        >
            <DialogTitle
                sx={{
                    pt: 2,
                    pb: 1,
                    pr: 1,
                    pl: 2,
                    m: 0,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Typography variant="h5" color={meetingTitleTextColor} fontWeight={400}>
                            {currentMeeting.id !== undefined ? 'Toplantı Güncelle / ' : 'Toplantı Ekle'}
                        </Typography>
                        <Typography variant="h5" color={meetingTitleTextColor} fontWeight={400}>
                            {currentMeeting.id !== undefined ? getMeetingTitleByMeeting(currentMeeting) : ''}
                        </Typography>
                    </div>
                    {value === 3 && (
                        <Button
                            variant="outlined"
                            color="inherit"
                            size="small"
                            onClick={() => setIsFullScreen(!isFullScreen)}
                        >
                            {isFullScreen ? "Tam Ekrandan Çık" : "Tam Ekran"}
                        </Button>
                    )}
                </div>
            </DialogTitle>

            <DialogContent
                dividers
                sx={{
                    p: 0,
                    m: 0,
                    overflow: value === 3 ? 'hidden' : 'visible',
                }}
            >
                <MeetingCard
                    addMeetingDialogStatus={open}
                    value={value}
                    setValue={setValue}
                    setTabsLength={setTabsLength}
                    onClose={onClose}
                    afterUpdateFunc={afterUpdateFunc}
                    addAfterTable={addAfterTable}
                    updateDecisionCount={updateDecisionCount}
                    saveButtonStatus={saveButtonStatus}
                    setSaveButtonStatus={setSaveButtonStatus}
                    type={"dialog"}
                />
            </DialogContent>

            <DialogActions
                sx={{
                    // DialogActions'ın padding ve margin ayarlarını sıfırlıyoruz
                    p: 1,
                    m: 0,
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)' // isteğe bağlı, üst çizgi ekleyebilirsiniz
                }}
            >
                <Button id="saveButton" variant="outlined" onClick={handleClose}>
                    Kapat
                </Button>
                <Button
                    variant="outlined"
                    onClick={handlePreviousTab}
                    disabled={value === 0}
                >
                    GERİ
                </Button>
                <Button
                    variant="outlined"
                    onClick={handleNextTab}
                    disabled={(currentMeeting.id === undefined && value === 0) || value === tabsLength - 1}
                >
                    İLERİ
                </Button>

                {value === 0 && (
                    <Button
                        id="saveButton"
                        disabled={isButtonDisabled}
                        variant="contained"
                        onClick={handleSaveButtonClick}
                    >
                        {currentMeeting.id !== undefined ? "Güncelle" : "Kaydet"}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateMeetingDialog;